import React from 'react';
import './smallSpinner.css';

const SmallLoader = () => {
  return <div class="lds-dual-ring"></div>;
};

export default SmallLoader;
